<template>
  <div class="component">
    <p>{{ title }}</p>
    <p>{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .component {
    margin-bottom: 40px;
    color: $fb-grey-dark-50;
    p {
      margin: 0 0 7px 0;
      font-weight: 300;
    }
    p:first-child { font-size: 30px; }
    p:last-child { font-size: 18px; }
  }
</style>
